import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EvaluacionDto } from '../dto/evaluacion-dto';
import { Observable, throwError } from 'rxjs';
import { RespuestaDto } from '../dto/respuesta-dto';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvadocCuestionarioRespuestaService {

  url = `${environment.host}/respuestas`;

  constructor(private http: HttpClient) { }

  public GuardarRespuesta(respuesta: EvaluacionDto): Observable<RespuestaDto> {
    return this.http.post<RespuestaDto>(`${this.url}`, respuesta).pipe(catchError(error => {
      console.log('Error service Respuestas-guardarRespuesta', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
